import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './i18n';

import React from 'react';

import Swap, { SwapProps } from './components/Swap';
import Widget, { WidgetProps } from './components/Widget';

export { ALL_SUPPORTED_CHAIN_IDS, DEFAULT_LOCALE, networkConfigs, SUPPORTED_LOCALES } from './constants';
export { darkTheme } from './theme';
export { SupportedChainId } from './types';

// types
export type { SupportedLocale } from './constants';
export type { DefaultTokenOptions, defaultTypedValueOptions, ReferrerOptions } from './types';
export type SwapWidgetProps = SwapProps & WidgetProps;
export type { Web3Provider } from '@ethersproject/providers';
export type { Theme } from '@mui/material';

export function SwapWidget(props: SwapWidgetProps) {
  return (
    <Widget {...props}>
      <Swap {...props} />
    </Widget>
  );
}
